import Api from 'libs/api/index';
import axios from 'axios';
import AuthService from '../../../services/Auth';

class Footfalls extends Api {
  constructor() {
    super('admin/footfalls/');
  }

  getExcel(params) {
    const apiUrl = process.env.REACT_APP_API_URL;
    return axios({
      url: `${apiUrl}/admin/footfalls.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob', // important
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  }

  getEdit(day, id) {
    return this.buildQuery(
      'get',
      {
        params: {
          day,
          shopping_center_id: id,
        },
      },
      'edit',
    );
  }

  getSingleItem(id) {
    return this.buildQuery('get', {}, id);
  }

  updateEdit(data, day, id) {
    return this.buildQuery(
      'post',
      {
        params: {
          day,
          shopping_center_id: id,
        },
        data,
      },
      'update',
    );
  }

  importExcel(data) {
    return this.buildQuery(
      'post',
      {
        headers: {
          'content-type':
            'multipart/form-data; boundary=----WebKitFormBoundaryqTqJIxvkWFYqvP5s',
        },
        data,
      },
      'import_create',
    );
  }
}

export default Footfalls;
